import { ROLE_LABELS } from '@/features/common/labels';
import type { Language } from '@/i18n/types';

// English translations for the same dex role codes as ROLE_LABELS (features/common/labels.ts).
// Kept as a separate map rather than changing ROLE_LABELS's shape — that RO-only Record is
// also consumed directly by UsersAdminPage.tsx and asserted key-by-key by
// __tests__/rbacRoleKeys.test.ts, both outside the cabinet-i18n scope.
const ROLE_LABELS_EN: Record<string, string> = {
  AUTHENTICATED: 'Authenticated user',
  CONSILIER_AGRICOL: 'Agricultural advisor',
  CAMERA_AGRICOLA: 'Chamber of agriculture',
  CCAR: 'CCAR',
  COMPANIE_INPUT: 'Input supply company',
  AIPA: 'AIPA',
  MAIA_ADMIN: 'MAIA',
  CONTENT_ADMIN: 'Content administrator',
  SYSTEM_ADMIN: 'System administrator',
  ORGANIZATIE_CERCETARE: 'Research and innovation organization',
  INSTITUTIE_FORMARE: 'Vocational training institution',
  FURNIZOR_CONSILIERE: 'Advisory services provider',
  ASOCIATIE_PROFESIONALA: 'Professional association',
  ANALYST: 'Analyst / report viewer',
};

export function roleLabel(role: string | undefined, language: Language): string {
  if (!role) return '';
  if (language === 'en') return ROLE_LABELS_EN[role] ?? ROLE_LABELS[role] ?? role;
  return ROLE_LABELS[role] ?? role;
}
